import PropTypes from "prop-types";
import HighchartsReact from "highcharts-react-official";
import Highcharts from 'highcharts'
import { useArgonController } from "context";
import { useEffect, useState } from "react";
import colorsDark from "assets/theme-dark/base/colors";
import colors from "assets/theme/base/colors";

const StrukturAnggaranChartPie = ({ data, title }) => {
    const [controller] = useArgonController();
    const { darkMode } = controller;

    const [options, setOptions] = useState({})

    useEffect(() => {
        setOptions({
            chart: {
                type: 'pie',
                backgroundColor: darkMode && colorsDark.background.dark
            },
            title: {
                align: 'center',
                text: title,
                style: {
                    color: darkMode ? colorsDark.text.main : colors.text.main
                }
                // margin: 35
            },
            lang: {
                numericSymbols: null,
                thousandsSep: ','
            },
            subtitle: {
                align: 'center',
                // text: 'Klik kecamatan untuk melihat Data Kelurahan'
            },
            accessibility: {
                announceNewData: {
                    enabled: true
                }
            },
            xAxis: {
                type: 'category',
                labels: {
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    },
                    format: '{value}'
                }
            },
            yAxis: {
                title: {
                    text: 'Anggaran',
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    }
                },
                gridLineWidth: 0,
                // lineColor: 'transparent',
                // minorTickLength: 0,
                // tickLength: 0
                labels: {
                    style: {
                        color: darkMode ? colorsDark.text.main : colors.text.main
                    },
                }
            },
            legend: {
                enabled: false
            },
            credits: {
                enabled: false
            },
            exporting: {
                enabled: true,
            },
            // plotOptions: {
            //     series: {
            //         borderWidth: 0,
            //         dataLabels: {
            //             enabled: true,
            //             format: '{point.y:,.f}'
            //         }
            //     }
            // },
            plotOptions: {
                series: {
                    allowPointSelect: true,
                    cursor: 'pointer',
                    dataLabels: [{
                        enabled: true,
                        distance: 20,
                    }, {
                        enabled: true,
                        distance: -40,
                        format: '{point.percentage:.2f}%',
                        style: {
                            fontSize: '1.2em',
                            textOutline: 'none',
                            opacity: 0.7
                        },
                        filter: {
                            operator: '>',
                            property: 'percentage',
                            value: 10
                        }
                    }]
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px">{series.name}</span><br>',
                pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y}</b>'
            },
            series: [
                {
                    name: 'Anggaran',
                    colorByPoint: true,
                    data: data.series
                },
            ],
            drilldown: {
                breadcrumbs: {
                    position: {
                        align: 'left'
                    }
                },
                activeAxisLabelStyle: {
                    textDecoration: 'none',
                    color: darkMode ? colorsDark.text.main : colors.text.main,
                    // fontStyle: 'italic',
                    fontWeight: 'normal'
                },
                activeDataLabelStyle: {
                    textDecoration: 'none',
                    color: darkMode ? colorsDark.text.main : colors.text.main
                    // fontWeight: 'normal'
                },
                series: data.jenis
            }
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data, darkMode])

    return (
        <HighchartsReact
            highcharts={Highcharts}
            options={options}
        />
    )
}

StrukturAnggaranChartPie.propTypes = {
    data: PropTypes.object.isRequired,
    title: PropTypes.string.isRequired
}

export default StrukturAnggaranChartPie